import { Alert, AlertBody, AlertIcon, Button, Loader, RiErrorWarningLine, Stack } from 'component-library';
import { TFunction } from 'i18next';

type ProcessingPanelProps = {
  t: TFunction;
  error: string | undefined;
  onBack: () => void;
};

export const ProcessingPanel = ({ t, error, onBack }: ProcessingPanelProps) => {
  if (error) {
    return (
      <Stack spacing={4} className='items-center justify-center py-16'>
        <Alert type='error'>
          <AlertIcon>
            <RiErrorWarningLine size={20} />
          </AlertIcon>
          <AlertBody>{error}</AlertBody>
        </Alert>
        <Button variant='outline' onClick={onBack}>
          {t('global.ui.buttons.back')}
        </Button>
      </Stack>
    );
  }

  return (
    <Stack spacing={3} className='items-center justify-center py-16'>
      <Loader className='h-8 w-8' />
      <span className='typography-body2 text-text-secondary'>{t('shared.uploadCoordinates.excel.processing')}</span>
    </Stack>
  );
};
